"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _likeStateUtils = require("../../likeStateUtils");

var _attachmentService = require("@insided/deprecated-services/attachmentService");

var _topicService = require("@insided/shared/services/topicService");

var _topicService2 = require("../../services/topicService");

var _contentType = require("@insided/shared/utils/contentType");

var _OnDemandTranslations = require("@insided/shared/modules/HubAI/OnDemandTranslations");

var _TopicHeader = _interopRequireDefault(require("./TopicHeader"));

var _TopicBody = _interopRequireDefault(require("./TopicBody"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicWrapper, _Component);

  var _super = _createSuper(TopicWrapper);

  function TopicWrapper(props) {
    var _this$props$topic$lik, _this$props$topic$lik2, _this$props$topic$top, _this$props$topic$att, _votes, _this$props$topic$pol, _this$props$topic$pol2;

    var _this;

    (0, _classCallCheck2.default)(this, TopicWrapper);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      updatedContent: _this.props.topic.content,
      hasCurrentUserLiked: !!_this.props.currentUser && _this.props.currentUser.id !== null && ((_this$props$topic$lik = _this.props.topic.likedBy) === null || _this$props$topic$lik === void 0 ? void 0 : _this$props$topic$lik.includes(_this.props.currentUser.id.toString())),
      likedUsers: undefined,
      likedBy: (_this$props$topic$lik2 = _this.props.topic.likedBy) !== null && _this$props$topic$lik2 !== void 0 ? _this$props$topic$lik2 : [],
      topLikedBy: (_this$props$topic$top = _this.props.topic.topLikedBy) !== null && _this$props$topic$top !== void 0 ? _this$props$topic$top : [],
      showEditor: false,
      isLoading: false,
      pollSelectionLoading: false,
      editorErrors: [],
      hideTopicContent: _this.props.currentPage > 1,
      tags: _this.props.topic.tags,
      attachments: (_this$props$topic$att = _this.props.topic.attachments) !== null && _this$props$topic$att !== void 0 ? _this$props$topic$att : [],
      pollVotes: (_votes = (_this$props$topic$pol = _this.props.topic.poll) === null || _this$props$topic$pol === void 0 ? void 0 : _this$props$topic$pol.votes) !== null && _votes !== void 0 ? _votes : {},
      answeredPoll: (_this$props$topic$pol2 = _this.props.topic.pollVotedByUser) !== null && _this$props$topic$pol2 !== void 0 ? _this$props$topic$pol2 : false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "content", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLikeStatusToggle", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var currentUser, hasCurrentUserLiked, currentUserId, normalizedCurrentUser;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentUser = _this.props.currentUser;
              hasCurrentUserLiked = _this.state.hasCurrentUserLiked;
              currentUserId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;

              if (currentUserId) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              normalizedCurrentUser = _objectSpread(_objectSpread({}, currentUser), {}, {
                id: Number(currentUserId)
              });

              _this.setState(function (prevState) {
                return TopicWrapper.updateLikeState(prevState, currentUserId, normalizedCurrentUser, !hasCurrentUserLiked);
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleVoteStatusToggle", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$props, currentUser, topic, hasCurrentUserLiked, currentUserId, normalizedCurrentUser, likedByUser;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, currentUser = _this$props.currentUser, topic = _this$props.topic;
              hasCurrentUserLiked = _this.state.hasCurrentUserLiked;
              currentUserId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;

              if (currentUserId) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              normalizedCurrentUser = _objectSpread(_objectSpread({}, currentUser), {}, {
                id: Number(currentUserId)
              });
              likedByUser = !hasCurrentUserLiked;

              _this.setState(function (prevState) {
                return _objectSpread(_objectSpread({}, TopicWrapper.updateLikeState(prevState, currentUserId, normalizedCurrentUser, likedByUser)), {}, {
                  isSubscribed: likedByUser
                });
              });

              if (!likedByUser) {
                _context2.next = 13;
                break;
              }

              _context2.next = 11;
              return (0, _topicService2.voteIdea)(topic.id, String(currentUserId));

            case 11:
              _context2.next = 15;
              break;

            case 13:
              _context2.next = 15;
              return (0, _topicService2.unvoteIdea)(topic.id, String(currentUserId));

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlePollAnswer", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(selectedOption) {
        var _this$props2, _this$props2$topic, id, contentType, currentUser, pollVotes, res;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props2 = _this.props, _this$props2$topic = _this$props2.topic, id = _this$props2$topic.id, contentType = _this$props2$topic.contentType, currentUser = _this$props2.currentUser;

                if (currentUser) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                pollVotes = _this.state.pollVotes;

                _this.setState({
                  pollSelectionLoading: true
                });

                _context3.next = 7;
                return _axios.default.post("/community/api/".concat(contentType, "s/").concat(id, "/votePoll"), {
                  selectedOption: selectedOption
                });

              case 7:
                res = _context3.sent;

                if (res.status === 204) {
                  _this.setState({
                    pollSelectionLoading: false,
                    answeredPoll: true,
                    pollVotes: _objectSpread(_objectSpread({}, pollVotes), {}, (0, _defineProperty2.default)({}, currentUser.id, selectedOption))
                  });
                }

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOpeningPostChange", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _this$props$topic, id, contentType, _this$state, updatedContent, attachments, _e$response, _e$response$data, _e$response$data$erro;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props$topic = _this.props.topic, id = _this$props$topic.id, contentType = _this$props$topic.contentType;
              _this$state = _this.state, updatedContent = _this$state.updatedContent, attachments = _this$state.attachments;

              _this.setState({
                isLoading: true
              });

              _context4.prev = 3;
              _context4.next = 6;
              return (0, _topicService.editContent)(contentType, parseInt(id), String(updatedContent));

            case 6:
              _context4.next = 8;
              return (0, _attachmentService.saveAttachmentsToTopic)(id, contentType, attachments);

            case 8:
              _this.setState(function (state) {
                _this.content.current = state.updatedContent;
                return {
                  showEditor: false,
                  isLoading: false
                };
              });

              window.location.reload();
              _context4.next = 16;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](3);

              _this.setState({
                isLoading: false
              });

              if ((_e$response = _context4.t0.response) !== null && _e$response !== void 0 && (_e$response$data = _e$response.data) !== null && _e$response$data !== void 0 && (_e$response$data$erro = _e$response$data.errors) !== null && _e$response$data$erro !== void 0 && _e$response$data$erro.content) {
                _this.setState({
                  editorErrors: [{
                    category: 'Forum',
                    phrase: 'validation.text.required'
                  }]
                });
              } else {
                _this.setState({
                  editorErrors: [{
                    category: 'Forum',
                    phrase: "Something's gone wrong"
                  }]
                });
              }

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 12]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (content, attachments) {
      _this.setState({
        updatedContent: content,
        attachments: attachments
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCancel", function () {
      _this.setState({
        showEditor: false,
        updatedContent: _this.content.current
      });
    });
    _this.handlePollAnswer = _this.handlePollAnswer.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleVoteStatusToggle = _this.handleVoteStatusToggle.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TopicWrapper, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _this$props$topic2, content, attachments;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$props$topic2 = this.props.topic, content = _this$props$topic2.content, attachments = _this$props$topic2.attachments;
                this.setState({
                  attachments: attachments !== null && attachments !== void 0 ? attachments : []
                });
                this.content.current = content;

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          topic = _this$props3.topic,
          currentPage = _this$props3.currentPage,
          isPreview = _this$props3.isPreview,
          attachmentCdn = _this$props3.attachmentCdn,
          disableFileAttachments = _this$props3.disableFileAttachments,
          authors = _this$props3.authors,
          unlimitedEditPermission = _this$props3.unlimitedEditPermission,
          canEndUserAddPublicTags = _this$props3.canEndUserAddPublicTags,
          contentHelpfulnessData = _this$props3.contentHelpfulnessData,
          featuredImageSrcSet = _this$props3.featuredImageSrcSet,
          featuredImageSizes = _this$props3.featuredImageSizes,
          pinnedReply = _this$props3.pinnedReply,
          currentUser = _this$props3.currentUser,
          showPostActions = _this$props3.showPostActions,
          bestAnswer = _this$props3.bestAnswer,
          showReportContent = _this$props3.showReportContent,
          onEditorClick = _this$props3.onEditorClick,
          showReplyEditor = _this$props3.showReplyEditor,
          totalReplyCount = _this$props3.totalReplyCount,
          userSubscribed = _this$props3.userSubscribed;
      var _this$state2 = this.state,
          hasCurrentUserLiked = _this$state2.hasCurrentUserLiked,
          likedUsers = _this$state2.likedUsers,
          likedBy = _this$state2.likedBy,
          topLikedBy = _this$state2.topLikedBy,
          tags = _this$state2.tags,
          showEditor = _this$state2.showEditor,
          isLoading = _this$state2.isLoading,
          editorErrors = _this$state2.editorErrors,
          hideTopicContent = _this$state2.hideTopicContent,
          attachments = _this$state2.attachments,
          answeredPoll = _this$state2.answeredPoll,
          pollSelectionLoading = _this$state2.pollSelectionLoading,
          pollVotes = _this$state2.pollVotes;

      var updatedTopic = _objectSpread(_objectSpread({}, topic), {}, {
        likedBy: likedBy,
        topLikedBy: topLikedBy
      });

      return (0, _preact.h)("div", null, (0, _preact.h)(_TopicHeader.default, {
        topic: updatedTopic,
        isLiked: hasCurrentUserLiked,
        onVoteClick: this.handleVoteStatusToggle,
        currentUser: currentUser,
        totalLikedUsersCount: likedBy.length,
        totalReplyCount: totalReplyCount
      }), (0, _preact.h)(_TopicBody.default, {
        topic: updatedTopic,
        featuredImageSrcSet: featuredImageSrcSet,
        featuredImageSizes: featuredImageSizes,
        currentPage: currentPage,
        isPreview: isPreview,
        attachmentCdn: attachmentCdn,
        disableFileAttachments: disableFileAttachments,
        authors: authors,
        unlimitedEditPermission: unlimitedEditPermission,
        canEndUserAddPublicTags: canEndUserAddPublicTags,
        contentHelpfulnessData: contentHelpfulnessData,
        pinnedReply: pinnedReply,
        currentUser: currentUser,
        showPostActions: showPostActions,
        hasCurrentUserLiked: hasCurrentUserLiked,
        likedUsersRecord: likedUsers,
        tags: tags,
        bestAnswer: bestAnswer,
        showEditor: showEditor,
        isLoading: isLoading,
        editorErrors: editorErrors,
        hideTopicContent: hideTopicContent,
        attachments: attachments,
        answeredPoll: answeredPoll,
        pollSelectionLoading: pollSelectionLoading,
        pollVotes: pollVotes,
        isSubscribed: topic.contentType === _contentType.CONTENT_TYPE_IDEA ? this.state.isSubscribed : undefined,
        onPostChange: this.onChange,
        onPostCancel: this.onCancel,
        onPostSave: this.handleOpeningPostChange,
        onToggleLike: this.handleLikeStatusToggle,
        onPollAnswer: this.handlePollAnswer,
        onEditClick: function onEditClick() {
          return _this2.setState({
            showEditor: true
          });
        },
        onTagsChange: function onTagsChange(newTags) {
          return _this2.setState({
            tags: newTags
          });
        },
        onToggleFirstPost: function onToggleFirstPost() {
          return _this2.setState({
            hideTopicContent: !hideTopicContent
          });
        },
        showReportContent: showReportContent,
        onEditorClick: onEditorClick,
        showReplyEditor: showReplyEditor,
        userSubscribed: userSubscribed
      }));
    }
  }], [{
    key: "updateLikeState",
    value: // This content ref is responsible for storing the previous value of the post when we edit topic.
    // onChange method keeps updating the state and when we cancel the edit the content uses the value from state
    // which is changed. We can also set the value we receive from props but this is received from twig, and it is
    // not refreshed until we refresh the browser.
    function updateLikeState(prevState, currentUserId, normalizedCurrentUser, likedByUser) {
      var _prevState$likedUsers;

      var updatedLikedUsers = likedByUser ? _objectSpread(_objectSpread({}, prevState.likedUsers), {}, (0, _defineProperty2.default)({}, currentUserId, normalizedCurrentUser)) : Object.fromEntries(Object.entries((_prevState$likedUsers = prevState.likedUsers) !== null && _prevState$likedUsers !== void 0 ? _prevState$likedUsers : {}).filter(function (_ref5) {
        var _ref6 = (0, _slicedToArray2.default)(_ref5, 1),
            key = _ref6[0];

        return key !== String(currentUserId);
      }));
      return _objectSpread({
        likedUsers: updatedLikedUsers
      }, (0, _likeStateUtils.updateLikedByState)(prevState.likedBy, prevState.topLikedBy, normalizedCurrentUser, likedByUser));
    }
  }]);
  return TopicWrapper;
}(_preact.Component);

var _default = (0, _OnDemandTranslations.withOnDemandTranslationProps)(TopicWrapper, ['isTranslationInProgress']);

exports.default = _default;
var cssAnchorName = 'topic-view';
exports.cssAnchorName = cssAnchorName;